export default __webpack_public_path__ + "static/media/explore.466db9f4.png";